import React from "react";
import layer3 from "../assets/I3.png";

const Footer = () => {
  return (
    <div className="z-[-1] relative h-[80px] md:h-[300px]">
      <img
        src={layer3}
        className="absolute bottom-0 w-full object-bottom object-cover"
        alt="layer1"
      />
    </div>
  );
};

export default Footer;
